module.exports = __webpack_public_path__ + "img/audiences.f783c80a.png";